<template>
  <div
    class="rich-textarea"
    :class="{ '-empty': !modelValue, disabled }"
    :contenteditable="disabled ? 'false' : 'plaintext-only'"
    role="textbox"
    :aria-multiline="singleLine ? 'false' : 'true'"
    :aria-disabled="disabled ? 'true' : undefined"
    :aria-placeholder="placeholder || undefined"
    :aria-label="placeholder || undefined"
    :data-placeholder="placeholder"
    spellcheck="true"
    @keydown="onKeydown"
    @input="onInput"
    @pointerdown="onPointerDown"
    @pointercancel="onPointerCancel"
    @focus="onFocus"
    @blur="onBlur"
    @copy="onCopy"
    @cut="onCut"
    @dragstart="onDragStart"
    @compositionstart="composing = true"
    @compositionend="onCompositionEnd"
  />
</template>

<script src="./rich_textarea.js"></script>

<style lang="scss">
@use "../../mixins";

.rich-textarea {
  position: relative;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  cursor: text;
  outline: none;

  /* out of the line, so the caret starts at its beginning, not after it;
     without offsets it stays where the text would start */
  &.-empty::before {
    content: attr(data-placeholder);
    position: absolute;
    color: var(--textFaint);
    pointer-events: none;
  }
}

/* a mentioned user; also in EmojiInput's hidden caret copy. The pill
   mixin keeps it within the field (else the field scrolls sideways) */
.rich-mention {
  @include mixins.mention-pill;

  user-select: all;
  cursor: default;
}

.rich-mention-avatar {
  @include mixins.mention-pill-avatar;

  flex: none;
}

.rich-mention-name {
  @include mixins.mention-pill-name;
}

/* also used in EmojiInput's hidden caret copy, which must match */
.rich-emoji {
  width: 1.4em;
  height: 1.4em;
  object-fit: contain;
  vertical-align: -0.3em;
}
</style>
